<jhi-bary-card titleKey="MAIL_TRANSPORTER_CONFIGURATION.BILLING.TITLE" icon="euro-sign" *ngIf="estimation">
  <div body class="d-flex flex-row">
    <ul class="list-unstyled flex-grow-1">
      <li>
        <p class="mb-2">
          <span class="bold">{{ 'LABEL.TRANSPORT' | translate }}&nbsp;: </span>
          &nbsp;{{ estimation.basePrice | currency: 'EUR' }}
        </p>
      </li>
      <li *ngIf="pricingOptions > 0">
        <p class="mb-2">
          <span class="bold"> {{ 'LABEL.OPTIONS_AND_EXTRA_COSTS' | translate }}&nbsp;: </span>
          &nbsp;{{ pricingOptions | currency: 'EUR' }}
        </p>
      </li>
      <li *ngIf="estimation.insurance">
        <p class="mb-2">
          <span class="bold">{{ 'LABEL.INSURANCE' | translate }}&nbsp;: </span>
          &nbsp;{{ estimation.insurance | currency: 'EUR' }}
        </p>
      </li>
      <li>
        <p class="mb-2" *ngIf="estimation.gazoleTaxAmount">
          <span class="bold">{{ 'LABEL.FUEL_TAX' | translate }}&nbsp;: </span>
          &nbsp;{{ estimation.gazoleTaxAmount | currency: 'EUR' }}
        </p>
        <br />
      </li>
      <li>
        <p class="mb-2">
          <span class="bold">{{ 'LABEL.TOTAL_PRE_TAXES_PRICE' | translate }}&nbsp;: </span>
          &nbsp;{{ estimation.priceHT | currency: 'EUR' }}
          <br />
        </p>
      </li>
      <ng-container *ngIf="isTransportOrder(transport)">
        <li>
          <p class="mb-2">
            <span class="bold">{{ 'LABEL.VAT' | translate: { vatRate: transport.vatRate } }}&nbsp;: </span>
            &nbsp;{{ estimation.vat() | currency: 'EUR' }}
          </p>
        </li>
        <li>
          <p class="mb-2">
            <span class="bold">{{ 'LABEL.TOTAL_FULL_TAXES_PRICE' | translate }}&nbsp;: </span>
            &nbsp;{{ estimation.ttc() | currency: 'EUR' }}
          </p>
        </li>
      </ng-container>
      <ng-container *ngIf="isTransport(transport)">
        <li>
          <p class="mb-2">
            <span class="bold">{{ 'LABEL.VAT' | translate: { vatRate: estimation.vatRate() } }}&nbsp;: </span>
            &nbsp;{{ estimation.vat() | currency: 'EUR' }}
          </p>
        </li>
        <li>
          <p class="mb-2">
            <span class="bold">{{ 'LABEL.TOTAL_FULL_TAXES_PRICE' | translate }}&nbsp;: </span>
            &nbsp;{{ estimation.ttc() | currency: 'EUR' }}
          </p>
        </li>
      </ng-container>
    </ul>
  </div>
</jhi-bary-card>
